import type { User } from "@/types/Sidebar.type";
import { UserRoleEnum, normalizeRole } from "@/types/role.type";

/** Resolve the active role from admin flag, study context, or first assigned role. */
export function getPrimaryRole(
  user: User,
  selectedStudyId?: string,
  userStudyRoles?: Record<string, string>,
): string {
  if (user.isAdmin) {
    return UserRoleEnum.TENANT;
  }

  if (selectedStudyId && userStudyRoles?.[selectedStudyId]) {
    return normalizeRole(userStudyRoles[selectedStudyId]);
  }

  if (!user.roles || user.roles.length === 0 || !user.roles[0]) {
    return UserRoleEnum.TENANT;
  }

  return normalizeRole(user.roles[0].role);
}

const RBQM_ALLOWED_ROLES = new Set<string>([
  UserRoleEnum.TENANT,
  UserRoleEnum.PROJECT_MANAGER,
  UserRoleEnum.CRA,
  UserRoleEnum.CTA,
  UserRoleEnum.DATA_MANAGER,
  UserRoleEnum.QA_QC,
  UserRoleEnum.SPONSOR,
]);

export const canAccessRbqmCenter = (role: string): boolean =>
  RBQM_ALLOWED_ROLES.has(role);
